export default __webpack_public_path__ + "024b52576a9bfc77de0408a6f0c0a4a3.svg";